var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',{attrs:{"fixed-header":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[_c('th',{staticClass:"grey lighten-2 font-weight-bold subtitle-1",attrs:{"colspan":3}},[_c('span',[_vm._v(_vm._s(_vm.$t("SKIT")))])])])]),_c('tbody',[_c('tr',[_c('td',{staticClass:"width-2"},[_vm._v(" "+_vm._s(_vm.detailsSection.title ? _vm.detailsSection.title : _vm.$route.query.section)+" ")]),_c('td',[_c('router-link',{attrs:{"to":{
              name: 'Detail Skit',
              params: {
                section: _vm.$route.params.section,
                skit:
                  _vm.detailsSection.conversation &&
                  _vm.detailsSection.conversation.length
                    ? _vm.detailsSection.conversation[0].Id
                    : null,
              },
            }}},[_vm._v("編集")])],1)])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }